import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalFunctionsService } from '../services/global-functions.service';
import {Observable} from 'rxjs';

// 
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})




export class AuthenticationService {

  currentUserVAR: any;
  sessionBrandId: any;

  

  

  constructor(private http: HttpClient, public gfunc: GlobalFunctionsService) { }

            login(username: string, password: string, app_build) {
                return this.http.post<any>(this.gfunc.apiURL + '/api/authenticate/hash', { username: username, password: password, app_build })
                // return this.http.post<any>(this.gfunc.apiURL + 'api/authenticate', { username: username, password: password })
                .pipe(map((user: any) => {




              if(!user){
                /// alert('There seems be the incorrect username or password')
                 ///this.gfunc.logout();
                }


                        // login successful if there's a jwt token in the response
                        if (user && user.token) {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                          //  localStorage.setItem('currentUser', JSON.stringify(user));
                            // Now can be setup to remove the session or will be logged out when browser closes.
                            // Also the new window will allow for another loggin session.
                            // Duplicate window will copy the session.
                            // If you want to use the sessionStorage



                            
                            sessionStorage.setItem('currentUser', JSON.stringify(user));
                            // session setup correctly?
              this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser') as string);
                            this.gfunc.setLoginSessionVars();
                           // this.sessionBrandId = this.currentUserVAR.brand_id;
                           // this.gfunc.getBrandById(this.sessionBrandId);
                        }

                        return user;
                    }));
             
            };




   login2(username: string, password: string) : any {
  return  this.http.post<any>(this.gfunc.apiURL + '/api/authenticate/hash', { username: username, password: password }).pipe(map(data => {


      console.log(data);
      let user = data;

       if (user != null ) {
         // store user details and jwt token in local storage to keep user logged in between page refreshes
       //  localStorage.setItem('currentUser', JSON.stringify(user));
         // Now can be setup to remove the session or will be logged out when browser closes.
         // Also the new window will allow for another loggin session.
         // Duplicate window will copy the session.
         // If you want to use the sessionStorage
         sessionStorage.setItem('currentUser', JSON.stringify(user));
         // session setup correctly?
// this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser') as string as string);
         this.gfunc.setLoginSessionVars();
        // this.sessionBrandId = this.currentUserVAR.brand_id;
        // this.gfunc.getBrandById(this.sessionBrandId);
     }

     return user;

    }))
     

    }


  logout() {
      // remove user from local storage to log user out
      localStorage.removeItem('currentUser');
      sessionStorage.removeItem('currentUser');
      sessionStorage.removeItem('sessionBrandName');
      sessionStorage.removeItem('sessionBrandTypeId');
  }
}

